import { Upload } from "antd";
import React from "react";
import { RcCustomRequestOptions } from "antd/es/upload/interface";
import { UploadProps } from "antd/lib/upload";

interface UploadPageProps extends UploadProps {
    onUpload: (options: RcCustomRequestOptions) => void;
    children: React.ReactNode;
}

export default function Index({
    onUpload,
    children,
    ...restProps
}: UploadPageProps) {
    const uploadProps = {
        accept: "image/*",
        name: "file",
        multiple: true,
        showUploadList: false, //是否展示文件列表
        ...restProps,
        customRequest: onUpload //通过覆盖默认的上传行为，可以自定义自己的上传实现
    };

    return (
        <div>
            <Upload {...uploadProps}>{children}</Upload>
        </div>
    );
}
